import {Injectable} from '@angular/core';
import {filter, take} from 'rxjs/operators';
import {setUser, setUserSuccess} from '@iw-shared/store/actions/user.action';
import {Store} from '@ngrx/store';
import {AppState} from '@iw-shared/store/state/app.state';
import { setInjectionToken, userId} from '@iw-shared/store/actions/storage.action';
import {AuthenticationService} from '@iw-shared/core/services/authentication.service';
import {Router} from '@angular/router';
import {EnvironmentService} from "@iw-shared/core/services/environment.service";
import {environment} from "@account-environments/environment";

@Injectable({
  providedIn: 'root'
})
export class AppInitStorageService {

  constructor(
    private store: Store<AppState>,
    private environmentService: EnvironmentService,
    private router: Router,
    private authenticationService: AuthenticationService
  ) {
  }

  /*  injectToken(): Promise<void>{
      return new Promise<void>((resolve, reject) => {

      });
    }*/

  init() {
    return new Promise<void>((resolve, reject) => {
      this.environmentService.setEnvironment({
        urlApi: environment.urlApi,
        urlMainApi: environment.urlMainApi,
        urlS3: environment.urlS3,
        urlProductDB: environment.urlProductDB
      });

      let params = new URLSearchParams(window.location.search);
      let token = params.get('token');
      if (token) {
        let payloadString = token.split('.');
        if (payloadString[1]) {
          this.store.dispatch(userId({userId: null}));
          // Vorab ausloggen, damit die Authentication-Cookies (insbesondere die Captcha-Authentifizierung) gelöscht werden
          let payload: any = JSON.parse(atob(payloadString[1]));
          this.store.dispatch(setInjectionToken({token, expiredIn: payload.exp}));
          if (params.get('action') == 'login') {
            this.store.dispatch(setUserSuccess({
              user: {
                id: payload.userId,
                email: payload.email,
                username: payload.username,
                role: '',
              }
            }));
            this.router.navigate(["/shop/dashboard"]).then();
          }
        }
      }

      // Der Kunde hat einen aktiven Token
      if(this.authenticationService.isAuthentication()){
        this.store.select(state => state).pipe(
          take(1)
        )
          .subscribe(
            state => {
              // Keine UserId, aber im Storage ist eine erfasst > User neu laden
              if (!state.user.id &&
                state.storage.userId) {
                this.store.dispatch(setUser({userId: state.storage.userId}))
              }
            }
          );
      } else {
        this.store.dispatch(userId({userId: null}))
      }

      this.store.select(state => state)
        .pipe(
          filter(state =>
            !state.authentication.isLoading || !state.authentication.isLoading == undefined
          ),
          take(1)
        )
        .subscribe(
          r => {
            resolve()
          }
        )
    });
  }
}
